'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body style={{ padding: 40, fontFamily: 'monospace' }}>
        <h2>Error occured</h2>
        <pre style={{ whiteSpace: 'pre-wrap', color: 'red' }}>
          {error.stack ?? error.message}
        </pre>
        {error.digest && (
          <p style={{ color: '#888' }}>Digest: {error.digest}</p>
        )}
        <button
          onClick={() => reset()}
          style={{
            marginTop: 16,
            padding: '8px 16px',
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
